import React, { Component } from "react";
import _ from "lodash";
import Container from "react-bootstrap/esm/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import TournamentApi from "./../api/tournamentApi";

class TournamentSelector extends Component {
  state = {
    tournaments: [],
  };

  async componentDidMount() {
    await this.loadTournaments();
  }

  loadTournaments = async () => {
    const { success, data: tournaments, message } = await TournamentApi.getTournaments();

    if (!success) {
      toast.error(message);
      return;
    }

    this.setState({ tournaments });
  };

  render() {
    const tournaments = _.chain(this.state.tournaments).orderBy("startDate", "desc").value();

    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Col>
              <h1>Tournaments:</h1>
              {tournaments.length === 0 && (
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              <div className="list-group">
                {tournaments.map((tournament) => {
                  return (
                    <Link className="list-group-item list-group-item-action" to={`${process.env.PUBLIC_URL}/?id=${tournament.id}`} key={tournament.id}>
                      {tournament.name}
                    </Link>
                  );
                })}
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default TournamentSelector;
